export type SupabaseAuthUrlError = {
  error: string | null;
  errorCode: string | null;
  errorDescription: string | null;
};

function parseAuthParams(raw: string): SupabaseAuthUrlError | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const query = trimmed.startsWith('?') || trimmed.startsWith('#') ? trimmed.slice(1) : trimmed;
  const params = new URLSearchParams(query);
  const error = params.get('error');
  const errorCode = params.get('error_code');
  const errorDescription = params.get('error_description');
  if (!error && !errorCode && !errorDescription) return null;
  return { error, errorCode, errorDescription };
}

/** Reads Supabase auth errors from query string or URL hash (invite, magic link, recovery). */
export function getSupabaseAuthUrlError(href = window.location.href): SupabaseAuthUrlError | null {
  const url = new URL(href);
  return parseAuthParams(url.search) ?? parseAuthParams(url.hash);
}

export function isExpiredAuthLinkError(err: SupabaseAuthUrlError | null): boolean {
  if (!err) return false;
  const code = (err.errorCode ?? '').toLowerCase();
  const desc = (err.errorDescription ?? '').toLowerCase();
  if (code === 'otp_expired') return true;
  if (desc.includes('expired') || desc.includes('abgelaufen')) return true;
  if (desc.includes('invalid or has expired') || desc.includes('link is invalid')) return true;
  if (
    err.error === 'access_denied' &&
    (code === '403' || code === '401' || code === 'otp_expired') &&
    desc.includes('invalid')
  ) {
    return true;
  }
  return false;
}
